import { Dispatch } from 'redux'

import { SelectOptionLocal } from '../../../types/common/commonTypes'
import { apiInstance } from '../../api/apiInstance'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const getAllOilsBrands =
    (searchTerm: string, typeId?: string) =>
    async (dispatch: Dispatch): Promise<void> => {
        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'oilsBrands', value: true } })

        try {
            const {
                data: { status, data },
            } = await apiInstance.post('/dicts/avito/OilsBrands', { typeId })
            const oilsBrands: SelectOptionLocal[] = []

            if (status === 'ok') {
                const parser = new DOMParser()
                const xmlDoc = parser.parseFromString(data, 'text/xml')
                const brandsNodes = xmlDoc.getElementsByTagName('Brand')

                for (let i = 0; i < brandsNodes.length; i++) {
                    const brandName = brandsNodes[i].textContent?.trim()
                    if (brandName && brandName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) {
                        oilsBrands.push({ name: brandName, value: brandName })
                    }
                }
            }
            dispatch({ type: storeDispatchTypes.setAllOilsBrands, value: { oilsBrands } })
        } catch (e) {
            console.error('load oilsBrands failed', e)
        }

        dispatch({ type: storeDispatchTypes.setPartsLoader, value: { field: 'oilsBrands', value: false } })
    }

export default getAllOilsBrands
